<script lang="ts">
  import { createEventDispatcher } from "svelte";
  type size = {
    width: number;
    height: number;
  };

  export let smImage: string;
  export let mdImage: string;
  export let lgImage: string | undefined = undefined;
  export let xlImage: string | undefined = undefined;
  export let altText: string;
  export let smSize: size = { width: 767, height: 767 };
  export let mdSize: size = { width: 1199, height: 782 };
  export let lgSize: size = { width: 1200, height: 480 };
  export let xlSize: size = { width: 1600, height: 480 };
  // export let fallbackSize: size = { width: 1200, height: 480 };
  export let cover = false;

  const dispatch = createEventDispatcher();

  const imageIsLoaded = e => {
    dispatch("imageLoaded", e);
  };
</script>

<style lang="scss">
  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
  }

  .cover {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
</style>

<picture class={cover ? "cover" : ""}>
  <source
    width={xlSize.width}
    height={xlSize.height}
    srcset={xlImage}
    media="(min-width: 1600px)"
  />
  <source
    width={lgSize.width}
    height={lgSize.height}
    srcset={lgImage}
    media="(min-width: 1280px)"
  />
  <source
    width={mdSize.width}
    height={mdSize.height}
    srcset={mdImage}
    media="(min-width: 768px)"
  />
  <source
    width={smSize.width}
    height={smSize.height}
    srcset={smImage}
    media="(max-width: 767px)"
  />
  <img
    id="staticImage"
    width={smSize.width}
    height={smSize.height}
    src={smImage}
    alt={altText}
    on:load={e => {
      imageIsLoaded(e);
    }}
  />
</picture>
